import React, { PureComponent } from 'react';
import styled from 'styled-components';

const StartText = styled.p`
  width: 100%;
  // text: 20px;
  font-size: 1.5em;
  font-weight: 400;
  color: #000;
  line-height: 1.2;
  text-transform: none;

  font-family: HelveticaNeueLTPro-Roman;
`;
const Title = styled.p`
  font-family: HelveticaNeueLTPro-Bd;
  font-size: 1.6em;
  font-weight: 400;
  color: #000;
  line-height: 1.2;
  text-transform: none;
`;

export default class GetStart extends PureComponent {
  render() {
    return (
      <div>
        <Title>Select a chair to begin.</Title>
        <StartText>
          SILQ is yours to create. As a canvas for personal expression, you can
          style your chair by choosing from a variety of fabrics, finishes and
          features.
        </StartText>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/accords/GetStart.js